import React ,{useState , useEffect} from "react";
import LazyLoad from "react-lazyload";
import { SectionWrapper, GallerySlider } from "raffle-house-uikit";
import Header from "../Header/Header";
import TimelineBlock from "../TimelineBlock/TimelineBlock";
import PartnersBlock from "../PartnersBlock/PartnersBlock";
import WinnerClub from "../WinnerClub/WinnerClub";
import Footer from "../Footer/Footer";
import MobileCTAButtonBottom from "../common/MobileCTAButtonBottom/MobileCTAButtonBottom";
import BottomTickerSection from "../BottomTickerSection/BottomTickerSection";
import BottomBigCTAButtonSection from "../common/BottomBigCTAButtonSection/BottomBigCTAButtonSection";
import Hero from "../Hero/Hero";
import DreamDraw from "../DreamDraw/DreamDraw";
import BonusDraw from "../BonusDraw/BonusDraw";
import Testimonials from "../Testimonials/Testimonials";
import Faq from "../Faq/Faq";
import HowItWorks from "../HowItWorks/HowItWorks";
import Charity from "../Charity/Charity";
import { useMediaQuery } from "../../hooks/useMediaQuery";

import "./styles.scss";

const Main = (props) => {
  const {
    prize,
    prizeId,
    raffles,
    raffle,
    onCTAClick,
    onTwo4One,
    onMoreWinnersClick,
    widgets,
    winners,
    bonusDraw,
    content,
  } = props;
  const isMobile = useMediaQuery("(max-width: 575px)");
  const [isDouble, setIsDouble] = useState(false);

  useEffect(() => {
    if (props.raffles && props.raffles.length > 1) {
      setIsDouble(true);
    }
  }, [props.raffles]);
  return (
    <>
      {prizeId ? (
        <div className="app">
          <Header
            raffle={raffle}
            onCTAClick={onCTAClick}
            bonusDraw={bonusDraw}
          />
          <main>
            <Hero onCTAClick={onCTAClick} onTwo4One={onTwo4One}  content={content} raffles={raffles}/>
            <SectionWrapper bg="bg-1">
                {isDouble && (<div className="update__2-4-1">
                  <button className="update__2-4-1-button" onClick={onTwo4One}>
                    <p>
                      View 2-4-1 Home Offer
                    </p>
                  </button>
                </div>
                )}
            </SectionWrapper>
            {!isMobile && (
              <SectionWrapper bg="bg-1">
                <Charity />
              </SectionWrapper>
            )}
            <SectionWrapper bg="bg-1">
              <DreamDraw content={content} isDouble={isDouble} />
            </SectionWrapper>
            {isMobile && (
              <SectionWrapper bg="bg-1">
                <Charity />
              </SectionWrapper>
            )}
            <SectionWrapper bg="bg-3">
              <Testimonials
                winners={winners}
                onMoreWinnersClick={onMoreWinnersClick}
              />
            </SectionWrapper>
              <SectionWrapper bg="bg-1">
                <GallerySlider data={content.dreamHome.gallery} />
              </SectionWrapper>
            {bonusDraw && (
              <SectionWrapper bg="bg-2">
                <BonusDraw onCTAClick={onCTAClick} bonusDraw={bonusDraw} image={content.bonusDraw.mainImage} videoData={content.dreamHome.bonusDraw}/>
              </SectionWrapper>
            )}
            <SectionWrapper bg="bg-2">
              <TimelineBlock
                // data={data.stepper}
                // widget={widgets.timelineWidget}
                onCTAClick={onCTAClick}
                content={content.dreamHome.timeLine}
              />
            </SectionWrapper>
            <SectionWrapper bg="bg-3">
              <HowItWorks onCTAClick={onCTAClick} />
            </SectionWrapper>
            <SectionWrapper bg="bg-3">
              <Faq content={content.dreamHome}/>
            </SectionWrapper>
            <SectionWrapper bg="bg-3">
              <PartnersBlock isTicker withoutContainer />
            </SectionWrapper>
            <SectionWrapper bg="bg-1">
              <LazyLoad height={200}>
                <WinnerClub isDark />
              </LazyLoad>
            </SectionWrapper>
            <Footer
              insideComponent={true}
              widget={widgets.footerWidget}
              bonusDraw={bonusDraw}
            />
            <MobileCTAButtonBottom
              variant="variant-2"
              onClick={onCTAClick}
              currentRaffle={prize}
              raffles={raffles}
              withCountdown
            />
            <BottomTickerSection variant={"variant-1"} raffles={raffles} />
            <BottomBigCTAButtonSection onClick={onCTAClick} />
          </main>
        </div>
      ) : (
        <main className="no-prize">
          <h1>No prize</h1>
        </main>
      )}
    </>
  );
};

export default Main;
